var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 4.5,
    r: 2,
    stroke: "#9f5448"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 4.5,
    r: 2,
    stroke: "#9f5448",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.655287 4.13776C0.455262 4.32814 0.447442 4.64463 0.637821 4.84466C0.828201 5.04468 1.14469 5.0525 1.34471 4.86212L0.655287 4.13776ZM1.34471 4.86212C4.28113 2.06731 6.45064 0.959472 8.52378 1.0398C10.6211 1.12107 12.7746 2.41852 15.6765 4.88117L16.3235 4.11872C13.4213 1.65578 11.0343 0.136333 8.5625 0.0405538C6.0665 -0.0561629 3.6381 1.2988 0.655287 4.13776L1.34471 4.86212Z",
    fill: "#9f5448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.339 4.86756C16.542 4.68035 16.5548 4.36402 16.3676 4.16103C16.1803 3.95803 15.864 3.94523 15.661 4.13244L16.339 4.86756ZM0.655542 4.86242C3.73881 7.79288 6.21571 9.21612 8.71228 9.12705C11.1937 9.03852 13.5309 7.45728 16.339 4.86756L15.661 4.13244C12.855 6.72028 10.7585 8.05342 8.67662 8.12769C6.6099 8.20142 4.39388 7.03587 1.34446 4.13758L0.655542 4.86242Z",
    fill: "#9f5448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView2);
export default __webpack_public_path__ + "static/media/view2.6179ff9898af3fe5707abe5391aa91cd.svg";
export { ForwardRef as ReactComponent };